import { useEffect } from "react";
import userManager, {
  signinRedirectCallback,
  signoutRedirect,
  loadUserFromStorage,
} from "../../auth/userServices";
import { useNavigate } from "react-router-dom";

import logger from "../../utils/logger";
import {
  authResultIsAdmin,
  authResultIsNumberNameUser,
  authResultIsPortalUser,
  authResultIsQueryUser,
  isQueryServicePortalEnabled,
} from "../../utils/authUtils";
import { User } from "oidc-client-ts";
import { useIsAdminUser } from "../../hooks/useIsAdminUser";
import { useIsNnsrPortalUser } from "../../hooks/useIsNnsrPortalUser";
import { useIsQueryPortalUser } from "../../hooks/useIsQueryPortalUser";

const Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    async function signinAsync() {
      logger.log("Inside Callback!");
      await signinRedirectCallback()
        .then((res: User) => {
          logger.log("Callback success!!", res);
          loadUserFromStorage();
          navigate(whereToRedirect(res));
        })
        .catch((err: any) => {
          logger.error("Callback Error!!", err);
          signoutRedirect();
        });
    }
    signinAsync();
  }, []);

  return <div>Redirecting...</div>;
};

function whereToRedirect(user: User): string {
  if (authResultIsAdmin(user)) {
    return "/admin/caselist";
  }
  if (authResultIsPortalUser(user)) {
    return "/caselist";
  }
  if (authResultIsQueryUser(user)) {
    return "/query-service/lookup";
  }

  if (authResultIsNumberNameUser(user)) {
    return "/number-name/request";
  }

  return "";
}

export default Callback;
